import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'prep-toolbar-docs',
  templateUrl: './toolbar-docs.component.html',
  styleUrls: ['./toolbar-docs.component.scss']
})
export class ToolbarDocsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }


  clickGoTpQuickStartGuide() {
    const link = document.createElement('a');
    link.target = '_blank';
    link.href = 'assets/document/PREP-Quick-Start-Guide.pdf';
    link.setAttribute('visibility', 'hidden');
    link.click();
  }

}
